export class PricingPublicModel {
  constructor() {
    this.priceList = [];
  }
}
